export function getSchoolTypes(schools) {
    return schools !== undefined ? Array.from(new Set(schools.map(x=>x.school_type))) : []
}